import { useEffect, useState, type FormEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { api, errorMessage } from '../api';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const qc = useQueryClient();

  useEffect(() => {
    document.title = 'SweetText';
  }, []);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.auth.login(email.trim(), password);
      qc.clear();
      const from = (location.state as { from?: string } | null)?.from;
      navigate(from && from !== '/login' ? from : '/inbox', { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login">
      <form className="card" onSubmit={submit}>
        <div className="brand-line">
          <span style={{ fontWeight: 700, fontSize: 18 }}>SweetText</span> <span className="by">by LeadAlchemy</span>
        </div>
        <h1 style={{ marginBottom: 16, textAlign: 'center' }}>Sign in</h1>
        <label className="field">
          <span>Email</span>
          <input className="input" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus required />
        </label>
        <label className="field">
          <span>Password</span>
          <input className="input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </label>
        {error && (
          <div className="notice danger" style={{ marginBottom: 12 }} role="alert">
            {error}
          </div>
        )}
        <button className="btn primary" type="submit" disabled={busy || !email || !password} style={{ width: '100%', justifyContent: 'center' }}>
          {busy ? 'Signing in' : 'Sign in'}
        </button>
        <p className="muted small" style={{ marginTop: 12, marginBottom: 0 }}>
          Forgot your password? Ask an admin to reset it in Settings.
        </p>
        <div className="tagline">The texting inbox for water dealers</div>
      </form>
    </div>
  );
}
